export const readablePayoutType = {
  ONCE: 'Einmalzahlung',
  RECURRING: 'Lebenslange Rente',
  COMBINED: 'Kombination aus Einmalzahlung und lebenslanger Rente'
}
